$(document).ready(function() {
	var dirRtlFlag = false;
	if ($("html").attr('dir') == 'rtl') {
		dirRtlFlag = true;
	}

	// shops slider
	$('#hp-shops').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		rtl: dirRtlFlag,
		responsive: [{
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}, {
				breakpoint: 1100,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 993,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 769,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});

	// events slider
	$('#hp-events').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 3000,
		fade: true,
		appendArrows: '.events__items',
		rtl: dirRtlFlag,
	});

	$('.events__items .slick-prev').click(function(e){
		e.preventDefault();
		$('#hp-events').slick('slickPrev');
	})
	
	$('.events__items .slick-next').click(function(e){
		e.preventDefault();
		$('#hp-events').slick('slickNext');
	})

	$('#advs').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 500,
		fade: true,
		rtl: dirRtlFlag,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
	});

  $('.shops__items').slick({
		dots: false,
		infinite: true,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
		autoplaySpeed: 500,
		fade: true,
		rtl: dirRtlFlag,
    responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
	});

  $('.autocomplete').autocomplete({
    width: 'flex',
     lookup: function (query, done) {
         var result;
         $.ajax({
           type: "GET",
           url: 'index.php?dir=site&page=shops&op=search&q='+query,
           dataType: 'json',
           success: function(data){
              console.log(132);
              // $('i.search__icon.fal.fa-search.fa-flip-horizontal').hide();
             done(data);
           }
         });
     },
     onSelect: function (suggestion) {
         window.location = suggestion.data;
     }
  });

})
console.log('itai FZ');
